module.exports = __webpack_public_path__ + "img/event-table-ronde.685566d2.png";